
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const Mangleshwar=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Mangleshwar Mahadev Temple</h1>
           <p className="sub-heading">A serene hilltop shrine in Sonbhadra, offering divine blessings and breathtaking views</p>
         </div>
         <div className="description">
         Nestled atop the Mangleshwar hills in Sonbhadra, Uttar Pradesh, Mangleshwar Mahadev Temple is an ancient site of worship dedicated to Lord Shiva. Renowned for its naturally formed Shivling and stunning panoramic views, this temple attracts devotees and tourists alike. The lush greenery, serene ambiance, and mesmerizing sunrise and sunset views make it an ideal destination for spiritual seekers and nature lovers. Special festivities on Maha Shivratri and year-round scenic charm make it a must-visit spot.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Mangleshwar MAHADEV/mahadev.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Mangleshwar MAHADEV/mahadev2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Mangleshwar MAHADEV//mahadev3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Mangleshwar MAHADEV/mahadev4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Mangleshwar MAHADEV/mahadev5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Mangleshwar MAHADEV/mahadev6.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Mangleshwar MAHADEV/mahadev7.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
          
         </div>
   
         <BookSection />
       </div>
     );
};